import NotFoundError from "./NotFoundError";

/**
 * A datasource that no longer exists in Ediphi. Its message is prose written for the user, so callers
 * may show it directly — unlike a NotFoundError raised from a 404, whose message is raw server text.
 */
export default class DatasourceGoneError extends NotFoundError {
  constructor(message: string, info?: any, cause?: Error) {
    super(message, info, cause);
    this.name = "DatasourceGoneError";
  }
}
